import React, { Component, PropTypes } from 'react';
import * as Icons from 'components/Material/SvgIcons';

export default class Tag extends Component {
  static propTypes = {
    mini: PropTypes.bool,
    controls: PropTypes.bool,
    onDelete: PropTypes.func
  };

  static defaultProps = {
    controls: false,
    mini: true
  };

  getStyle() {
    if (this.props.mini) {
      return {
        borderRadius: '6px',
        backgroundColor: '#DDD',
        marginRight: '3px',
        padding: '1px 4px',
        fontSize: '10px',
        lineHeight: '12px',
        cursor: 'pointer',
        display: 'inline-block'
      };
    } else {
      return {
        borderRadius: '14px',
        backgroundColor: '#DDD',
        marginRight: '3px',
        height: '28px',
        lineHeight: '24px',
        padding: '2px 6px',
        cursor: 'pointer',
        display: 'inline-block',
        boxSizing: 'border-box'
      };
    }
  }

  _onDelete() {
    if (this.props.onDelete) {
      this.props.onDelete(this.props.name);
    }
  }

  render() {
    let { style, name, ...other } = this.props,
      controls;
    if (this.props.controls) {
      controls = (
        <Icons.ContentClear
          style={{ verticalAlign: 'middle' }}
          onTouchTap={this._onDelete.bind(this)}
          hoverColor="#AAAAAA"
        />
      );
    }
    return (
      <div style={Object.assign(this.getStyle(), style)} {...other}>
        {name}
        {this.props.children}
        {controls}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Tag.js